/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, signal} from '@angular/core';
import {finalize} from 'rxjs';

import template from './tcf-page.component.html';
import {SIMPLE_PAGE_IMPORTS} from './simple-page-imports';
import {TcfApiService} from './tcf-api.service';

@Component({
  standalone: true,
  imports: SIMPLE_PAGE_IMPORTS,
  selector: 'adn-tcf-page',
  template
})
export class TcfPageComponent {
  tcf = '';
  gdpr = 'GDPR_ON';
  auTagId = '';
  readonly doing = signal(false);
  readonly gdprResults = signal<any>(null);

  constructor(private readonly tcfApi: TcfApiService) {
  }

  findPurposes(): void {
    this.doing.set(true);
    const gdprParam = this.gdpr === 'GDPR_AD_UNIT' && this.auTagId ? this.auTagId : (this.gdpr || 0);
    this.tcfApi.checkTcf(gdprParam, this.tcf).pipe(
      finalize(() => this.doing.set(false))
    ).subscribe((data) => this.gdprResults.set(data));
  }
}
